import { z } from "zod";

export const ratingSchema = z.object({
    /** When the rating was created */
    createdAt: z.date(),
    /** Unique rating identifier */
    id: z.string().describe("Unique rating identifier"),
    /** The rating */
    rating: z.number().int().min(1).max(5),
    /** The user who rated the book */
    uid: z.string(),
    /** When the rating was updated */
    updatedAt: z.date(),
});

export type Rating = z.infer<typeof ratingSchema>;
